<template>
  <v-flex d-flex xs6 sm3 md3 lg2 :title="promotion.promotion_name">
    <v-card style="cursor: pointer" height="100%">
      <template>
        <v-responsive
          :aspect-ratio="1"
          style="background-position: center; background-size: cover"
        >
          <v-img
            v-if="promotion.promotion_image"
            :src="promotion.promotion_image"
            :lazy-src="`@/assets/img/products/default-photo.png`"
            aspect-ratio="1"
            class="white"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-layout> </template
          ></v-img>
          <v-img
            v-else
            :src="`@/assets/img/products/default-photo.png`"
            aspect-ratio="1"
            class="white"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-layout> </template
          ></v-img>
        </v-responsive>
      </template>

      <v-card-title primary-title class="pt-3">
        <div>
          <div class="caption mb-2 mt-0">{{ promotion.promotion_name }}</div>
          <div class="body-1 mb-1" :style="{ color: theme.color }">
            <div>เริ่ม:&nbsp;{{ promotion.promotion_start_date }}</div>
            <div>สิ้นสุด:&nbsp;{{ promotion.promotion_end_date }}</div>
          </div>
        </div>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    promotion: Object
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  }
}
</script>
